import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@app/store';
import { GameMode } from './types';

interface GameModeState {
  selectedMode: GameMode;
}

const initialState: GameModeState = {
  selectedMode: "CsGo"
};

export const gameModeSlice = createSlice({
  name: 'gameMode',
  initialState,
  reducers: {
    setGameMode: (state, action: PayloadAction<GameMode>) => {
      state.selectedMode = action.payload;
    },
  },
});

export const { setGameMode } = gameModeSlice.actions;
export const selectGameMode = (state: RootState) => state.gameMode.selectedMode; 